import { subscribeToAgentJob, unsubscribeFromAgentJob } from "../channels/agent_job_channel";

export default function registerAgentPanel(Alpine) {
  Alpine.store("agentPanel", {
    isOpen: false
  });

  Alpine.data("agentPanel", () => ({
    activeJobId: null,
    activeAgentInitials: "",
    activeAgentName: "",
    showNewForm: false,
    status: null,
    tokensUsed: 0,

    init() {
      const url = new URL(window.location);
      const openJob = url.searchParams.get("open_agent_job");
      if (openJob) {
        url.searchParams.delete("open_agent_job");
        window.history.replaceState({}, "", url);
        this.$store.agentPanel.isOpen = true;
        this.$nextTick(() => this.openJob(openJob));
      }
    },

    destroy() {
      unsubscribeFromAgentJob();
    },

    toggle() {
      this.$store.agentPanel.isOpen = !this.$store.agentPanel.isOpen;
      if (this.$store.agentPanel.isOpen) {
        this.showNewForm = false;
        this.activeJobId = null;
        unsubscribeFromAgentJob();
        this.loadJobList();
        // Close chat panel if open
        if (this.$store.chat) this.$store.chat.isOpen = false;
      }
    },

    closePanel() {
      this.$store.agentPanel.isOpen = false;
      this.activeJobId = null;
      this.showNewForm = false;
      unsubscribeFromAgentJob();
    },

    loadJobList() {
      const frame = document.getElementById("agent-job-list");
      if (frame) {
        frame.src = "/agent_jobs?panel=true";
      }
    },

    openJob(jobId, initials = "AI", name = "Agent") {
      this.activeJobId = jobId;
      this.activeAgentInitials = initials;
      this.activeAgentName = name;
      this.showNewForm = false;
      this.tokensUsed = 0;
      this.status = null;

      const frame = document.getElementById("agent-job-detail");
      if (frame) {
        frame.src = `/agent_jobs/${jobId}?panel=true`;
      }

      subscribeToAgentJob(jobId, {
        onMessage: (data) => {
          const container = document.getElementById("panel_agent_messages");
          if (!container) return;

          if (data.message_id && document.getElementById(`message_${data.message_id}`)) return;

          const typingIndicator = document.getElementById("panel-typing-indicator");
          if (typingIndicator) typingIndicator.remove();

          container.insertAdjacentHTML("beforeend", data.html);
          this.scrollToBottom();
        },
        onMessageUpdate: (data) => {
          const existing = document.getElementById(`message_${data.message_id}`);
          if (existing) {
            existing.outerHTML = data.html;
            this.scrollToBottom();
          }
        },
        onTokenUpdate: (tokens) => {
          this.tokensUsed = tokens;
        },
        onStatusUpdate: (newStatus) => {
          this.status = newStatus;
          if (["completed", "failed", "awaiting_approval", "cancelled"].includes(newStatus)) {
            const frame = document.getElementById("agent-job-detail");
            if (frame) {
              frame.src = `/agent_jobs/${this.activeJobId}?panel=true`;
            }
          }
        }
      });

      this.scrollToBottom();
    },

    handleJobCreated(event) {
      const { id, initials, name } = event.detail || {};
      if (id) {
        this.openJob(id, initials || "AI", name || "Agent");
      }
    },

    backToList() {
      this.activeJobId = null;
      this.showNewForm = false;
      unsubscribeFromAgentJob();
      this.loadJobList();
    },

    openNewForm(params = "") {
      this.showNewForm = true;
      this.activeJobId = null;
      unsubscribeFromAgentJob();
      const frame = document.getElementById("agent-new-form");
      if (frame) {
        const extra = params ? `&${params}` : "";
        frame.src = `/agent_jobs/new?panel=true${extra}`;
      }
    },

    startEmmaExplorer(event) {
      const { opportunityId, customerId, emailThreadId, jobId, agentInitials, agentName, mode } = event.detail || {};
      this.$store.agentPanel.isOpen = true;
      if (this.$store.chat) this.$store.chat.isOpen = false;
      this.$nextTick(() => {
        if (jobId) {
          this.openJob(jobId, agentInitials || "EE", agentName || "Emma Explorer");
          return;
        }
        const parts = ["agent_slug=emma_explorer"];
        if (mode === "new_opportunity" && emailThreadId) {
          parts.push("job_type=new_opportunity");
          parts.push(`seed_email_thread_id=${emailThreadId}`);
        } else if (mode === "new_opportunity" && customerId) {
          parts.push(`job_type=new_opportunity`);
          parts.push(`seed_customer_id=${customerId}`);
        } else if (opportunityId) {
          parts.push(`seed_opportunity_id=${opportunityId}`);
        }
        this.openNewForm(parts.join("&"));
      });
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const el = document.getElementById("panel_agent_messages");
        if (el) el.scrollTop = el.scrollHeight;
      });
    }
  }));
}
